import { MoreHoriz } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, Tooltip, styled } from '@mui/material'
import { useState } from 'react'
import { BucketShareType, BucketType, BucketUserRole } from '../../../../../graphql/generated'
import { activeAlbumIdVar, drawerVar, modalVar } from '../../../../../providers/apollo/cache'
import useBucket from '../../../hooks/useBucket'
import useProfilePlan from '../../../hooks/useProfilePlan'

const DropdownButton = styled(IconButton)(({ theme }) => ({
  height: '32px',
  width: '32px',
  '&:hover': {
    background: theme.palette.primary.highlight
  }
})) as typeof IconButton

export default function BucketMenuNew() {
  const { bucket, bucketUser } = useBucket()
  const { isSharingEnabled } = useProfilePlan()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isPersonalBucket = bucket?.bucketType === BucketType.Mybucket
  const isGroupBucket = bucket?.bucketType === BucketType.Group
  const isViewer = bucketUser?.userRole === BucketUserRole.Viewer
  const canShareOwnBucket = isPersonalBucket && isSharingEnabled
  const canShareGroupBucket = isGroupBucket && !isViewer
  const canShareBucket = canShareGroupBucket || canShareOwnBucket

  const shareTooltip = () => {
    if (isGroupBucket && isViewer) {
      return 'Your role for this bucket does not allow you to share buckets.'
    }
    if (isPersonalBucket && !isSharingEnabled) {
      return "Your plan doesn't support sharing media."
    }
    return ''
  }

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const openSettingsModal = () => {
    modalVar('bucketSettings')
    drawerVar(null)
    handleClose()
  }

  const openShareModal = () => {
    modalVar('bucketSharingLinkCreate')
    drawerVar(null)

    // Since the modal already has the bucket id, pass in BUCKET as the albumId var so we know we're sharing a bucket, not an album
    activeAlbumIdVar(BucketShareType.Bucket)
    handleClose()
  }

  return (
    <>
      <DropdownButton onClick={handleOpen} data-testid="bucket-menu">
        <MoreHoriz fontSize="small" />
      </DropdownButton>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <MenuItem onClick={openSettingsModal} data-testid="bucket-menu-settings">
          Bucket Settings
        </MenuItem>
        <Tooltip title={shareTooltip()}>
          <div>
            <MenuItem data-testid="bucket-menu-share-bucket" disabled={!canShareBucket} onClick={openShareModal}>
              Share Bucket
            </MenuItem>
          </div>
        </Tooltip>
      </Menu>
    </>
  )
}
